import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { Typography, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningIcon from '@mui/icons-material/Warning';

function APIKeyListItem(props) {
  const {
    apiKey,
    deleteAPIKey,
    isVeryIdle
  } = props;

  const [deletingKey, setDeletingKey] = useState(false)
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false)

  const handleConfirmDelete = () => {
    setDeletingKey(true);
    deleteAPIKey(apiKey.id)
      .catch(() => {})
      .finally(() => {
        setDeletingKey(false);
        setConfirmDeleteOpen(false);
      });
  };

  const getKeyStatus = () => {
    const createdAt = new Date(apiKey.attributes.created_at);
    const updatedAt = new Date(apiKey.attributes.updated_at);

    if (createdAt.getTime() >= updatedAt.getTime()) {
      return { status: "Not Activated", color: "#1976d2" }; // blue
    }

    const now = new Date();
    const diffMinutes = (now - updatedAt) / (1000 * 60);
    
    if (diffMinutes < 60) {
      return { status: "Active", color: "#4caf50" }; // green
    } else {
      return { status: "Idle", color: "#ff9800" }; // orange
    }
  };

  const getTimeDiff = () => {
    const updatedAt = new Date(apiKey.attributes.updated_at);
    const now = new Date();
    const diffMinutes = Math.floor((now - updatedAt) / (1000 * 60));
    
    if (diffMinutes < 60) {
      return `${diffMinutes} minutes`;
    } else if (diffMinutes < 1440) { // less than 24 hours
      const hours = Math.floor(diffMinutes / 60);
      return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
    } else {
      const days = Math.floor(diffMinutes / 1440);
      return `${days} ${days === 1 ? 'day' : 'days'}`;
    }
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={3} sx={{padding: "13px 20px"}}>
          <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
            {isVeryIdle && (
              <Tooltip title="Very idle: consider removing this client">
                <WarningIcon color="warning" fontSize="small" />
              </Tooltip>
            )}
            <Typography sx={{textAlign: "left"}}><b>{apiKey.attributes.name}</b></Typography>
          </Box>
        </Grid>
        <Grid item xs={5} sx={{padding: "13px 20px"}}>
          <Typography component="div">Client ID: <pre style={{display: "inline", backgroundColor: "#eee", padding: "5px 10px", borderRadius: "5px"}}>{apiKey.attributes.auth0_client_id}</pre></Typography>
        </Grid>
        <Grid item xs={3} sx={{padding: "13px 20px"}}>
        <Typography>
            <Box
              component="span"
              sx={{
                display: 'inline-block',
                width: 8,
                height: 8,
                borderRadius: '50%',
                marginRight: 1,
                backgroundColor: getKeyStatus().color,
              }}
            />
            {getKeyStatus().status}
            <Typography 
              component="span" 
              sx={{ 
                color: 'text.secondary',
                fontSize: 'small',
                marginLeft: 1
              }}
            >
              (last seen: {getTimeDiff()} ago)
            </Typography>
          </Typography>
        </Grid>
        <Grid item xs={1} sx={{textAlign: "right", padding: "5px 20px"}}>
          <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1}}>
            <IconButton
              disabled={deletingKey}
              sx={{color: "red"}} 
              aria-label="delete" 
              onClick={() => {
                setConfirmDeleteOpen(true);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        </Grid>
        </Grid>
        <Dialog
          open={confirmDeleteOpen}
          onClose={() => {
            if (!deletingKey) {
              setConfirmDeleteOpen(false);
            }
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{backgroundColor: "#eee"}}>Delete API client?</DialogTitle>
          <DialogContent sx={{padding: "20px 40px"}}>
            <p>Delete API client "{apiKey.attributes.name}"? This cannot be undone.</p>
          </DialogContent>
          <DialogActions sx={{backgroundColor: "#eee"}}>
            <Button
              disabled={deletingKey}
              onClick={() => setConfirmDeleteOpen(false)}
            >
              Cancel
            </Button>
            <Button
              disabled={deletingKey}
              variant="contained"
              color="error"
              onClick={handleConfirmDelete}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
    </Box>
  );
}

export default APIKeyListItem;
